import { render, staticRenderFns } from "./SalesReportByLocation.vue?vue&type=template&id=61634c5e"
import script from "./SalesReportByLocation.vue?vue&type=script&lang=js"
export * from "./SalesReportByLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports